import * as React from 'react'

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    mql.addEventListener('change', onChange)
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    return () => mql.removeEventListener('change', onChange)
  }, [])

  return !!isMobile
}

// md to xl of App.css — #2873. Range syntax, like Tailwind's `md:max-xl:`, so a
// fractional width (zoom, OS scaling) such as 1279.5 px lands on the same side
// for the `md:max-xl:` classes and for this hook.
export const COMPACT_DESKTOP_QUERY = `(width >= ${MOBILE_BREAKPOINT}px) and (width < 1280px)`

/**
 * True between md and xl, where the navigation sidebar is kept collapsed (#2873).
 * Read on the first render, not in an effect, so the sidebar never paints open
 * and then snaps shut.
 */
export function useIsCompactDesktop() {
  const [matches, setMatches] = React.useState(
    () => window.matchMedia?.(COMPACT_DESKTOP_QUERY).matches ?? false
  )

  React.useEffect(() => {
    const mql = window.matchMedia(COMPACT_DESKTOP_QUERY)
    const onChange = () => setMatches(mql.matches)
    mql.addEventListener('change', onChange)
    onChange()
    return () => mql.removeEventListener('change', onChange)
  }, [])

  return matches
}
